// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-low,
.warning-low,
.success-low,
.accent-low,
.neutral-low,
.neutral-medium,
.neutral-high,
.black-low {
  border-radius: 8px;
  border: 1px solid var(--Global-Neutral-Grey-400, #ececed);
  background: var(--Global-Base-White, #fff);
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.error-low-icon,
.warning-low-icon,
.success-low-icon,
.accent-low-icon,
.neutral-low-icon,
.neutral-high-icon,
.black-low-icon {
  color: rgba(79, 77, 85, 1);
}

.error-low-title,
.warning-low-title,
.success-low-title,
.accent-low-title,
.neutral-low-title,
.neutral-medium-title,
.neutral-high-title,
.black-low-title {
  color: var(--Global-Neutral-Grey-1300, #0a090b);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.error-low-title-large,
.warning-low-title-large,
.success-low-title-large,
.accent-low-title-large,
.neutral-low-title-large,
.neutral-medium-title-large,
.neutral-high-title-large,
.black-low-title-large {
  color: var(--Global-Neutral-Grey-1300, #0a090b);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}

.error-low-desc-large,
.warning-low-desc-large,
.success-low-desc-large,
.accent-low-desc-large,
.neutral-low-desc-large,
.neutral-medium-desc-large,
.neutral-high-desc-large,
.black-low-desc-large,
.black-medium-desc-large {
  color: var(--Global-Neutral-Grey-1000, #4f4d55);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.error-low-icon-large,
.warning-low-icon-large,
.success-low-icon-large,
.accent-low-icon-large,
.neutral-low-icon-large,
.neutral-medium-icon-large,
.neutral-high-icon-large,
.black-low-icon-large,
.black-medium-icon-large {
  color: rgba(79, 77, 85, 1);
}

.error-medium {
  border-radius: 8px;
  border: 1px solid var(--Global-Red-300, #ffc9c9);
  background: #fde3d6;
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.success-medium {
  border-radius: 8px;
  border: 1px solid var(--Global-Green-300, #c1f4d4);
  background: #d5fbd2;
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.warning-medium {
  border-radius: 8px;
  border: 1px solid #ffe9ba;
  background: #fbefcb;
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.accent-medium {
  border-radius: 8px;
  border: 1px solid var(--Global-Purple-300, #e4e4ff);
  background: var(--Global-Purple-100, #f6f6ff);
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.black-medium {
  border-radius: 8px;
  border: 1px solid var(--Global-Neutral-Grey-600, #dcdcde);
  background: var(--Global-Neutral-Grey-300, #f1f1f1);
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.error-medium-icon,
.warning-medium-icon,
.success-medium-icon,
.accent-medium-icon,
.neutral-medium-icon,
.black-medium-icon {
  color: rgba(79, 77, 85, 1);
}

.error-medium-title {
  color: var(--Global-Red-1300, #260606);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.warning-medium-title,
.success-medium-title {
  color: var(--Global-Neutral-Grey-1300, #0a090b);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.accent-medium-title {
  color: var(--Global-Purple-1300, #010037);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.black-medium-title {
  color: var(--Global-Neutral-Grey-1000, #4f4d55);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.error-medium-title-large {
  color: var(--Global-Red-1300, #260606);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}

.success-medium-title-large {
  color: var(--Global-Green-1300, #001a0a);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}

.warning-medium-title-large {
  color: var(--Global-Neutral-Grey-1300, #0a090b);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}

.accent-medium-title-large {
  color: var(--Global-Purple-1300, #010037);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}

.neutral-medium-title-large,
.neutral-high-title-large {
  color: var(--Global-Neutral-Grey-1300, #0a090b);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}
.black-medium-title-large {
  color: var(--Global-Neutral-Grey-1000, #4f4d55);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.error-medium-desc-large {
  color: var(--Global-Red-1300, #260606);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.success-medium-desc-large {
  color: var(--Global-Green-1300, #001a0a);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.warning-medium-desc-large {
  color: var(--Global-Neutral-Grey-1300, #0a090b);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.accent-medium-desc-large {
  color: var(--Global-Purple-1300, #010037);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.neutral-medium-desc-large,
.neutral-high-desc-large,
.black-medium-desc-large {
  color: var(--Global-Neutral-Grey-1000, #4f4d55);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.error-medium-icon-large,
.warning-medium-icon-large,
.success-medium-icon-large,
.accent-medium-icon-large,
.neutral-medium-icon-large,
.neutral-high-icon-large,
.black-medium-icon-large {
  color: rgba(79, 77, 85, 1);
}

.error-high {
  border-radius: 8px;
  background: #b9232f;
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.warning-high {
  border-radius: 8px;
  background: #e28721;
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.success-high {
  border-radius: 8px;
  background: #03a068;
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.accent-high {
  border-radius: 8px;
  background: #403e9f;
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.black-high {
  border-radius: 8px;
  background: var(--Global-Neutral-Grey-1300, #0a090b);
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
}

.error-high-icon,
.warning-high-icon,
.success-high-icon,
.accent-high-icon,
.black-high-icon {
  color: rgba(255, 255, 255, 0.54);
}

.error-high-title,
.warning-high-title,
.success-high-title,
.accent-high-title {
  color: var(--Global-Base-White, #fff);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.black-high-title {
  color: var(--Global-Alpha-White-500, rgba(255, 255, 255, 0.62));

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.error-high-title-large,
.warning-high-icon-large,
.success-high-icon-large,
.accent-high-title-large,
.black-high-title-large {
  color: var(--Global-Base-White, #fff);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.02px;
}

.error-high-desc-large,
.warning-high-desc-large,
.success-high-desc-large,
.accent-high-desc-large,
.black-high-desc-large {
  color: var(--Global-Alpha-White-600, rgba(255, 255, 255, 0.54));

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.error-high-icon-large,
.warning-high-icon-large,
.success-high-icon-large,
.accent-high-icon-large,
.black-high-icon-large {
  color: rgba(255, 255, 255, 1);
}
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/customToaster/toast.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE,kBAAkB;EAClB,yDAAyD;EACzD,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;;;;;;;EAOE,0BAA0B;AAC5B;;AAEA;;;;;;;;EAQE,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;;;;EAQE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,6CAA6C;EAC7C,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;;EAEtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;;EAEzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;;EAEtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;;EAExC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;;EAEzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;;EAEtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;;EAExC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;;EAEzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;EAGE,+CAA+C;;EAE/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,oDAAoD;AACtD;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;;;;EAIE,qCAAqC;;EAErC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,+DAA+D;;EAE/D,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;EAKE,qCAAqC;;EAErC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;EAKE,+DAA+D;;EAE/D,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;EAKE,6BAA6B;AAC/B","sourcesContent":[".error-low,\n.warning-low,\n.success-low,\n.accent-low,\n.neutral-low,\n.neutral-medium,\n.neutral-high,\n.black-low {\n  border-radius: 8px;\n  border: 1px solid var(--Global-Neutral-Grey-400, #ececed);\n  background: var(--Global-Base-White, #fff);\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.error-low-icon,\n.warning-low-icon,\n.success-low-icon,\n.accent-low-icon,\n.neutral-low-icon,\n.neutral-high-icon,\n.black-low-icon {\n  color: rgba(79, 77, 85, 1);\n}\n\n.error-low-title,\n.warning-low-title,\n.success-low-title,\n.accent-low-title,\n.neutral-low-title,\n.neutral-medium-title,\n.neutral-high-title,\n.black-low-title {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.error-low-title-large,\n.warning-low-title-large,\n.success-low-title-large,\n.accent-low-title-large,\n.neutral-low-title-large,\n.neutral-medium-title-large,\n.neutral-high-title-large,\n.black-low-title-large {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n\n.error-low-desc-large,\n.warning-low-desc-large,\n.success-low-desc-large,\n.accent-low-desc-large,\n.neutral-low-desc-large,\n.neutral-medium-desc-large,\n.neutral-high-desc-large,\n.black-low-desc-large,\n.black-medium-desc-large {\n  color: var(--Global-Neutral-Grey-1000, #4f4d55);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.error-low-icon-large,\n.warning-low-icon-large,\n.success-low-icon-large,\n.accent-low-icon-large,\n.neutral-low-icon-large,\n.neutral-medium-icon-large,\n.neutral-high-icon-large,\n.black-low-icon-large,\n.black-medium-icon-large {\n  color: rgba(79, 77, 85, 1);\n}\n\n.error-medium {\n  border-radius: 8px;\n  border: 1px solid var(--Global-Red-300, #ffc9c9);\n  background: #fde3d6;\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.success-medium {\n  border-radius: 8px;\n  border: 1px solid var(--Global-Green-300, #c1f4d4);\n  background: #d5fbd2;\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.warning-medium {\n  border-radius: 8px;\n  border: 1px solid #ffe9ba;\n  background: #fbefcb;\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.accent-medium {\n  border-radius: 8px;\n  border: 1px solid var(--Global-Purple-300, #e4e4ff);\n  background: var(--Global-Purple-100, #f6f6ff);\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.black-medium {\n  border-radius: 8px;\n  border: 1px solid var(--Global-Neutral-Grey-600, #dcdcde);\n  background: var(--Global-Neutral-Grey-300, #f1f1f1);\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.error-medium-icon,\n.warning-medium-icon,\n.success-medium-icon,\n.accent-medium-icon,\n.neutral-medium-icon,\n.black-medium-icon {\n  color: rgba(79, 77, 85, 1);\n}\n\n.error-medium-title {\n  color: var(--Global-Red-1300, #260606);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.warning-medium-title,\n.success-medium-title {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.accent-medium-title {\n  color: var(--Global-Purple-1300, #010037);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.black-medium-title {\n  color: var(--Global-Neutral-Grey-1000, #4f4d55);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.error-medium-title-large {\n  color: var(--Global-Red-1300, #260606);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n\n.success-medium-title-large {\n  color: var(--Global-Green-1300, #001a0a);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n\n.warning-medium-title-large {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n\n.accent-medium-title-large {\n  color: var(--Global-Purple-1300, #010037);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n\n.neutral-medium-title-large,\n.neutral-high-title-large {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n.black-medium-title-large {\n  color: var(--Global-Neutral-Grey-1000, #4f4d55);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.error-medium-desc-large {\n  color: var(--Global-Red-1300, #260606);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.success-medium-desc-large {\n  color: var(--Global-Green-1300, #001a0a);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.warning-medium-desc-large {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.accent-medium-desc-large {\n  color: var(--Global-Purple-1300, #010037);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.neutral-medium-desc-large,\n.neutral-high-desc-large,\n.black-medium-desc-large {\n  color: var(--Global-Neutral-Grey-1000, #4f4d55);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.error-medium-icon-large,\n.warning-medium-icon-large,\n.success-medium-icon-large,\n.accent-medium-icon-large,\n.neutral-medium-icon-large,\n.neutral-high-icon-large,\n.black-medium-icon-large {\n  color: rgba(79, 77, 85, 1);\n}\n\n.error-high {\n  border-radius: 8px;\n  background: #b9232f;\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.warning-high {\n  border-radius: 8px;\n  background: #e28721;\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.success-high {\n  border-radius: 8px;\n  background: #03a068;\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.accent-high {\n  border-radius: 8px;\n  background: #403e9f;\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.black-high {\n  border-radius: 8px;\n  background: var(--Global-Neutral-Grey-1300, #0a090b);\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n}\n\n.error-high-icon,\n.warning-high-icon,\n.success-high-icon,\n.accent-high-icon,\n.black-high-icon {\n  color: rgba(255, 255, 255, 0.54);\n}\n\n.error-high-title,\n.warning-high-title,\n.success-high-title,\n.accent-high-title {\n  color: var(--Global-Base-White, #fff);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.black-high-title {\n  color: var(--Global-Alpha-White-500, rgba(255, 255, 255, 0.62));\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.error-high-title-large,\n.warning-high-icon-large,\n.success-high-icon-large,\n.accent-high-title-large,\n.black-high-title-large {\n  color: var(--Global-Base-White, #fff);\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.02px;\n}\n\n.error-high-desc-large,\n.warning-high-desc-large,\n.success-high-desc-large,\n.accent-high-desc-large,\n.black-high-desc-large {\n  color: var(--Global-Alpha-White-600, rgba(255, 255, 255, 0.54));\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.error-high-icon-large,\n.warning-high-icon-large,\n.success-high-icon-large,\n.accent-high-icon-large,\n.black-high-icon-large {\n  color: rgba(255, 255, 255, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
